/**
 * Thin wrapper of Immutable data around a single business
 * **/
import {StoreModel} from "../../../models/StoreModel";

export class BusinessModel extends StoreModel {

    constructor(data: any = {}) {
        super(data);
    }

    public getName() {
        return this.getKey('name');
    }

    public getAdnetCustomerId() {
        return this.getKey('adnetCustomerId');
    }

    public getAdnetTokenId() {
        return this.getKey('adnetToken');
    }

    // a wrapper around base class public setKey<T>(ClassName:any, key:string, value:any):T {...
    // so we don't have to pass in the generic every time
    public setModelKey(key: string, value: any): BusinessModel {
        return this.setData(BusinessModel, this._data.set(key, value)) as BusinessModel;
    }

    public setBusinessId(id: string) {
        return this.setKey<BusinessModel>(BusinessModel, 'businessId', id);
    }

    public getBusinessId() {
        return this.getKey('businessId');
    }

    invalidateBusinessId(i_businessId = -1) {
        return this.setKey<BusinessModel>(BusinessModel, 'businessId', i_businessId);
    }

}
